// extracted by mini-css-extract-plugin
export default {"content":"CollectionPointPage_content__GM7BP","tabsContainer":"CollectionPointPage_tabsContainer__hv+EO"};